import {AddressKeys, AddressValidationKeys} from "../lib/api/models";

export default function getValidationKey(addressKey: AddressKeys): AddressValidationKeys {
    if (addressKey === AddressKeys.AddressLine1) {
        return AddressValidationKeys.AddressLine1;
    }
    if (addressKey === AddressKeys.AddressLine2) {
        return AddressValidationKeys.AddressLine2;
    }
    if (addressKey === AddressKeys.City) {
        return AddressValidationKeys.City;
    }
    if (addressKey === AddressKeys.State) {
        return AddressValidationKeys.State;
    }
    return AddressValidationKeys.Zipcode;
}
